<template>
    <div class=text-block v-html="textContent"></div>
</template>
<script>
export default {
    name : 'textBlock',
    props : {
        textContent : String,
    }
}
</script>